import React, { forwardRef } from 'react';
import { Input, Button, Space } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

export const TextInput = forwardRef(({ 
  label,
  labelHelpText,
  error, 
  helperText,
  addonButton,
  addonButtonProps,
  layout,
  labelCol,
  wrapperCol,
  required,
  ...props 
}, ref) => {
  const input = addonButton ? (
    <Space.Compact style={{ width: '100%' }}>
      <Input 
        status={error ? 'error' : ''} 
        {...props} 
        style={{ width: 'calc(100% - 32px)' }}
        ref={ref}
      />
      <Button {...addonButtonProps}>
        {addonButton}
      </Button>
    </Space.Compact>
  ) : (
    <Input 
      ref={ref}
      status={error ? 'error' : ''} 
      {...props} 
    />
  );

  return (
    <InputWrapper
      label={label}
      labelHelpText={labelHelpText}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      {input}
    </InputWrapper>
  );
});

TextInput.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  addonButton: PropTypes.node,
  addonButtonProps: PropTypes.object,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
};

export default TextInput; 